import { createIcon } from '@chakra-ui/react';

export const InstagramIcon = createIcon({
  displayName: 'InstagramIcon',
  viewBox: '0 0 45 46',
  path: [
    <circle
      key="1"
      cx="22.5"
      cy="23"
      r="22.5"
      fill="url(#paint0_linear_4151_2127)"
    />,
    <circle
      key="2"
      cx="22.5"
      cy="23"
      r="22.5"
      fill="url(#paint1_radial_4151_2127)"
    />,
    <path
      key="3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1732 23.2526C17.1732 20.118 19.7596 17.5769 22.9502 17.5769C26.1408 17.5769 28.7272 20.118 28.7272 23.2526C28.7272 26.3872 26.1408 28.9283 22.9502 28.9283C19.7596 28.9283 17.1732 26.3872 17.1732 23.2526ZM22.9502 26.9368C20.8791 26.9368 19.2002 25.2873 19.2002 23.2526C19.2002 21.2178 20.8791 19.5684 22.9502 19.5684C25.0213 19.5684 26.7002 21.2178 26.7002 23.2526C26.7002 25.2873 25.0213 26.9368 22.9502 26.9368Z"
      fill="white"
    />,
    <path
      key="4"
      d="M28.9555 18.679C29.7011 18.679 30.3055 18.0852 30.3055 17.3527C30.3055 16.6202 29.7011 16.0263 28.9555 16.0263C28.2099 16.0263 27.6055 16.6202 27.6055 17.3527C27.6055 18.0852 28.2099 18.679 28.9555 18.679Z"
      fill="white"
    />,
    <path
      key="5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9502 12.2C19.8949 12.2 19.5118 12.2127 18.3118 12.2665C17.1144 12.3201 16.2966 12.507 15.581 12.7802C14.8412 13.0626 14.2138 13.4406 13.5884 14.055C12.963 14.6695 12.5783 15.2859 12.2908 16.0127C12.0127 16.7157 11.8225 17.5192 11.7679 18.6956C11.7131 19.8745 11.7002 20.2509 11.7002 23.2526C11.7002 26.2543 11.7131 26.6307 11.7679 27.8096C11.8225 28.986 12.0127 29.7894 12.2908 30.4925C12.5783 31.2193 12.963 31.8357 13.5884 32.4502C14.2138 33.0646 14.8412 33.4425 15.581 33.725C16.2966 33.9982 17.1144 34.185 18.3118 34.2387C19.5118 34.2925 19.8949 34.3052 22.9502 34.3052C26.0055 34.3052 26.3886 34.2925 27.5886 34.2387C28.786 34.185 29.6038 33.9982 30.3194 33.725C31.0592 33.4425 31.6865 33.0646 32.312 32.4502C32.9374 31.8357 33.3221 31.2193 33.6096 30.4925C33.8877 29.7894 34.0779 28.986 34.1325 27.8096C34.1872 26.6307 34.2002 26.2543 34.2002 23.2526C34.2002 20.2509 34.1872 19.8745 34.1325 18.6956C34.0779 17.5192 33.8877 16.7157 33.6096 16.0127C33.3221 15.2859 32.9374 14.6695 32.312 14.055C31.6865 13.4406 31.0592 13.0626 30.3194 12.7802C29.6038 12.507 28.786 12.3201 27.5886 12.2665C26.3886 12.2127 26.0055 12.2 22.9502 12.2ZM22.9502 14.1914C25.9541 14.1914 26.3099 14.2027 27.4962 14.2559C28.593 14.305 29.1887 14.4851 29.5851 14.6364C30.1102 14.8369 30.485 15.0764 30.8787 15.4632C31.2724 15.85 31.5161 16.2181 31.7202 16.7341C31.8743 17.1235 32.0576 17.7087 32.1076 18.7864C32.1617 19.9518 32.1732 20.3014 32.1732 23.2526C32.1732 26.2038 32.1617 26.5533 32.1076 27.7188C32.0576 28.7964 31.8743 29.3816 31.7202 29.7711C31.5161 30.287 31.2724 30.6552 30.8787 31.0419C30.485 31.4287 30.1102 31.6682 29.5851 31.8687C29.1887 32.0201 28.593 32.2002 27.4962 32.2493C26.3101 32.3025 25.9543 32.3138 22.9502 32.3138C19.9461 32.3138 19.5904 32.3025 18.4042 32.2493C17.3074 32.2002 16.7117 32.0201 16.3153 31.8687C15.7901 31.6682 15.4154 31.4287 15.0217 31.0419C14.6281 30.6552 14.3843 30.287 14.1802 29.7711C14.0261 29.3816 13.8428 28.7964 13.7928 27.7188C13.7387 26.5533 13.7272 26.2038 13.7272 23.2526C13.7272 20.3014 13.7387 19.9518 13.7928 18.7864C13.8428 17.7087 14.0261 17.1235 14.1802 16.7341C14.3843 16.2181 14.628 15.85 15.0217 15.4632C15.4154 15.0764 15.7901 14.8369 16.3153 14.6364C16.7117 14.4851 17.3074 14.305 18.4042 14.2559C19.5905 14.2027 19.9463 14.1914 22.9502 14.1914Z"
      fill="white"
    />,
    <defs key="6">
      <linearGradient
        id="paint0_linear_4151_2127"
        x1="2.62561"
        y1="2.86578"
        x2="16.8137"
        y2="57.7471"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4E60D3" />,
        <stop offset="0.142763" stopColor="#913BAF" />,
        <stop offset="0.761458" stopColor="#D52D88" />,
        <stop offset="1" stopColor="#F26D4F" />,
      </linearGradient>
      <radialGradient
        id="paint1_radial_4151_2127"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(13.6234 45.5) rotate(32.1601) scale(42.0276 30.2459)"
      >
        <stop stopColor="#FED276" />,
        <stop offset="0.17024" stopColor="#FDBD61" stopOpacity="0.975006" />,
        <stop offset="0.454081" stopColor="#F6804D" />,
        <stop offset="1" stopColor="#E83D5C" stopOpacity="0.01" />,
      </radialGradient>
    </defs>
  ]
});
